import { useEffect } from "react";

const DRAFT_KEY = "azv_draft_v1";
const UTM_KEY = "azv_utm";
const NEXT_KEY = "azv_post_login";

export const loadDraft = () => {
  try {
    return JSON.parse(localStorage.getItem(DRAFT_KEY)) || null;
  } catch {
    return null;
  }
};
export const saveDraft = (d) => localStorage.setItem(DRAFT_KEY, JSON.stringify({ ...d, saved_at: Date.now() }));
export const clearDraft = () => localStorage.removeItem(DRAFT_KEY);

export const captureUtm = () => {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach((k) => {
    if (p.get(k)) utm[k] = p.get(k).slice(0, 120);
  });
  if (Object.keys(utm).length) sessionStorage.setItem(UTM_KEY, JSON.stringify(utm));
};
export const getUtm = () => {
  try {
    return JSON.parse(sessionStorage.getItem(UTM_KEY)) || {};
  } catch {
    return {};
  }
};

export const setNext = (path) => localStorage.setItem(NEXT_KEY, path);
export const popNext = () => {
  const p = localStorage.getItem(NEXT_KEY);
  localStorage.removeItem(NEXT_KEY);
  return p;
};

export function useSeo(title, description, noindex = false) {
  useEffect(() => {
    document.title = title ? `${title} | Conexão Litigium` : "Conexão Litigium — Sua questão jurídica, em poucos passos.";
    const set = (name, content) => {
      let m = document.querySelector(`meta[name="${name}"]`);
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", name);
        document.head.appendChild(m);
      }
      m.setAttribute("content", content);
    };
    if (description) set("description", description);
    set("robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, noindex]);
}
